
import {
  LISTA_INDICADORES_REQUEST,
  LISTA_UTM_SUCCESS,
  LISTA_UF_SUCCESS,
  LISTA_DOLAR_SUCCESS,
  LISTA_BITCOIN_SUCCESS,
  LISTA_IPC_SUCCESS,
  LISTA_EURO_SUCCESS,
  LISTA_ETHEREUM_SUCCESS,
  LISTA_INDICADORES_FAIL,
} from "../../actions/Otros/types";



interface ValorIndicador {
  valor: string | number;
}

interface IndicadoresState {
  utm: ValorIndicador;
  uf: ValorIndicador;
  dolar: ValorIndicador;
  bitcoin: ValorIndicador;
  ipc: ValorIndicador;
  btc: ValorIndicador;
  euro: ValorIndicador;
  Ethereum: ValorIndicador,
  loading: boolean;
  error?: string;
}


const initialState: IndicadoresState = {
  utm: { valor: 0 },
  uf: { valor: 0 },
  dolar: { valor: 0 },
  bitcoin: { valor: 0 },
  ipc: { valor: 0 },
  btc: { valor: 0 },
  euro: { valor: 0 },
  Ethereum: { valor: 0 },
  loading: false,
  error: undefined,
};

const indicadoresReducers = (
  state: IndicadoresState = initialState,
  action: any
): IndicadoresState => {
  switch (action.type) {
    case LISTA_INDICADORES_REQUEST:
      return {
        ...state,
        loading: true,
        error: undefined,
      };

    case LISTA_UTM_SUCCESS:
      return {
        ...state,
        loading: false,
        utm: action.payload,
      };

    case LISTA_UF_SUCCESS:
      return {
        ...state,
        loading: false,
        uf: action.payload,
      };

    case LISTA_DOLAR_SUCCESS:
      return {
        ...state,
        loading: false,
        dolar: action.payload,
      };

    case LISTA_BITCOIN_SUCCESS:
      return {
        ...state,
        loading: false,
        btc: action.payload,
      };

    case LISTA_IPC_SUCCESS:
      return {
        ...state,
        loading: false,
        ipc: action.payload,
      };

    case LISTA_EURO_SUCCESS:
      return {
        ...state,
        loading: false,
        euro: action.payload,
      };
    case LISTA_ETHEREUM_SUCCESS:
      return {
        ...state,
        loading: false,
        Ethereum: action.payload,
      };

    case LISTA_INDICADORES_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};

export default indicadoresReducers;
